import {defineMessages} from "@project/i18n";

export const materialFunctionFieldLabelIds = {
  code: "fields.materialFunction.code",
  description: "fields.materialFunction.description",
  name: "fields.materialFunction.name",
} as const;

export const materialFunctionFieldMessages = defineMessages({
  code: {
    id: "fields.materialFunction.code",
    defaultMessage: "Code",
    description: "Material function field label for code",
  },
  description: {
    id: "fields.materialFunction.description",
    defaultMessage: "Description",
    description: "Material function field label for description",
  },
  name: {
    id: "fields.materialFunction.name",
    defaultMessage: "Name",
    description: "Material function field label for name",
  },
});
